<ng-container>
  <div
    class="dialog-heading d-flex align-items-center justify-content-between px-4 py-3"
  >
    <h1 class="text-xl fw-600 mb-0">
      Filter
      <ng-container *ngIf="appliedFilterCount"
        >({{ appliedFilterCount }})
      </ng-container>
    </h1>

    <button class="button-no-style" mat-dialog-close>
      <span
        class="cross-icon d-inline-block"
        [innerHTML]="crossBlackSVG | safeHTML"
      ></span>
    </button>
  </div>

  <mat-dialog-content>
    <form [formGroup]="filterForm">
      <div class="position-relative my-3" *ngIf="dialogData?.config?.category">
        <ng-container
          *ngTemplateOutlet="resetFilter; context: { controlName: 'category' }"
        ></ng-container>

        <app-input-label [label]="'Grievance Category'"></app-input-label>
        <searchable-dropdown
          [displayKey]="'label'"
          [valueMapKey]="'value'"
          [noEntryLabel]="'No Match'"
          [mainControl]="filterForm.controls['category']"
          [placeholderLabel]="'Select Category'"
          [rootPlaceholderLabel]=""
          [required]="false"
          [controlName]="'category'"
          [itemList]="categoryTypeList"
          class="search"
          [multiple]="true"
        >
        </searchable-dropdown>
      </div>

      <div
        class="position-relative my-3"
        *ngIf="dialogData?.config?.organizationType"
      >
        <ng-container
          *ngTemplateOutlet="
            resetFilter;
            context: { controlName: 'organizationType' }
          "
        ></ng-container>

        <app-input-label [label]="'Organization Type'"></app-input-label>
        <searchable-dropdown
          [displayKey]="'label'"
          [valueMapKey]="'value'"
          [noEntryLabel]="'No Match'"
          [mainControl]="filterForm.controls['organizationType']"
          [placeholderLabel]="'Select Organization Type'"
          [rootPlaceholderLabel]=""
          [required]="false"
          [controlName]="'organizationType'"
          [itemList]="organizationTypeList"
          class="search"
          [multiple]="true"
        >
        </searchable-dropdown>
      </div>

      <div class="mb-3 my-3" *ngIf="dialogData?.config?.uploadedOn">
        <app-input-label label="Upload Date"></app-input-label>

        <div class="d-flex gap-2 mt-2">
          <button
            [ngClass]="{
              active:
                filterForm.controls['dateFilterType'].value ===
                ActionDate.last7Days
            }"
            class="chip active"
            (click)="setActionDate(ActionDate.last7Days)"
          >
            {{ actionDateLabels["last-7-days"] }}
          </button>
          <button
            [ngClass]="{
              active:
                filterForm.controls['dateFilterType'].value ===
                ActionDate.last15Days
            }"
            class="chip"
            (click)="setActionDate(ActionDate.last15Days)"
          >
            {{ actionDateLabels["last-15-days"] }}
          </button>
          <button
            [ngClass]="{
              active:
                filterForm.controls['dateFilterType'].value ===
                ActionDate.custom
            }"
            class="chip"
            (click)="setActionDate(ActionDate.custom)"
          >
            {{ actionDateLabels["custom"] }}
          </button>
        </div>
      </div>

      <!-- @if (filterForm.controls['dateFilterType'].value === ActionDate.custom) { -->
      <app-date-range-input
        *ngIf="
          filterForm.controls['dateFilterType'].value === ActionDate.custom
        "
        label="Custom Date"
        [isRequired]="true"
        [startDateControl]="
          utilityService.$formControl(customDateRange.get('fromDate')!)
        "
        [endDateControl]="
          utilityService.$formControl(customDateRange.get('toDate')!)
        "
      ></app-date-range-input>

      <!-- } -->

      <div
        class="position-relative my-3"
        *ngIf="dialogData?.config?.artifactType"
      >
        <ng-container
          *ngTemplateOutlet="
            resetFilter;
            context: { controlName: 'artifactType' }
          "
        ></ng-container>
        <app-input-label [label]="'Artifact Type'"></app-input-label>
        <searchable-dropdown
          [displayKey]="'label'"
          [valueMapKey]="'value'"
          [noEntryLabel]="'No Match'"
          [mainControl]="filterForm.controls['artifactType']"
          [placeholderLabel]="'Select Type'"
          [rootPlaceholderLabel]=""
          [required]="false"
          [controlName]="'artifactType'"
          [itemList]="artifactTypeList"
          class="search"
          [multiple]="true"
        >
        </searchable-dropdown>
      </div>

      <div class="mb-3 my-3" *ngIf="dialogData?.config?.userStatus">
        <app-input-label label="User Status"></app-input-label>
        <div class="d-flex gap-2 mt-2">
          <button
            [ngClass]="{
              active:
                filterForm.controls['userStatus']?.value === UserStatus?.active
            }"
            class="chip active"
            (click)="setUserStatus(UserStatus?.active)"
          >
            {{ userStatusLabels[UserStatus?.active] }}
          </button>
          <button
            [ngClass]="{
              active:
                filterForm.controls['userStatus']?.value ===
                UserStatus?.inactive
            }"
            class="chip"
            (click)="setUserStatus(UserStatus?.inactive)"
          >
            {{ userStatusLabels[UserStatus?.inactive] }}
          </button>
          <button
            [ngClass]="{
              active:
                filterForm.controls['userStatus']?.value === UserStatus?.blocked
            }"
            class="chip"
            (click)="setUserStatus(UserStatus?.blocked)"
          >
            {{ userStatusLabels[UserStatus?.blocked] }}
          </button>
        </div>
      </div>

      <div class="mb-3 my-3" *ngIf="dialogData?.config?.visibilityStatus">
        <app-input-label label="Visibility"></app-input-label>
        <div class="d-flex gap-2 mt-2">
          <button
            [ngClass]="{
              active:
                filterForm.controls['visibility']?.value?.[0] ===
                VisibilityStatus?.open
            }"
            class="chip active"
            (click)="setVisibility(VisibilityStatus?.open)"
          >
            {{ visibilityStatusLabels[VisibilityStatus?.open] }}
          </button>
          <button
            [ngClass]="{
              active:
                filterForm.controls['visibility']?.value?.[0] ===
                VisibilityStatus?.restricted
            }"
            class="chip"
            (click)="setVisibility(VisibilityStatus?.restricted)"
          >
            {{ visibilityStatusLabels[VisibilityStatus?.restricted] }}
          </button>
          <button
            [ngClass]="{
              active:
                filterForm.controls['visibility']?.value?.[0] ===
                VisibilityStatus?.private
            }"
            class="chip"
            (click)="setVisibility(VisibilityStatus?.private)"
          >
            {{ visibilityStatusLabels[VisibilityStatus?.private] }}
          </button>
          <button
            *ngIf="dataConfig?.isSharedVisible"
            [ngClass]="{
              active:
                filterForm.controls['visibility']?.value?.[0] ===
                VisibilityStatus?.shared
            }"
            class="chip"
            (click)="setVisibility(VisibilityStatus?.shared)"
          >
            {{ visibilityStatusLabels[VisibilityStatus?.shared] }}
          </button>
        </div>
      </div>

      <div class="mb-3 my-3" *ngIf="dialogData?.config?.isActive">
        <app-input-label label="Discoverability"></app-input-label>
        <div class="d-flex gap-2 mt-2">
          <button
            [ngClass]="{
              active:
                filterForm.controls['isActive']?.value === ActiveStatus?.hidden
            }"
            class="chip active"
            (click)="setActiveStatus(ActiveStatus?.hidden)"
          >
            {{ activeStatusLabels[ActiveStatus?.hidden] }}
          </button>
          <button
            [ngClass]="{
              active:
                filterForm.controls['isActive']?.value === ActiveStatus?.active
            }"
            class="chip"
            (click)="setActiveStatus(ActiveStatus?.active)"
          >
            {{ activeStatusLabels[ActiveStatus?.active] }}
          </button>
        </div>
      </div>

      <!-- Instance Type Filter -->
      <div class="mb-3 my-3" *ngIf="dialogData?.config?.instanceTypes">
        <app-input-label label="Instance Type"></app-input-label>
        <div class="d-flex gap-2 mt-2">
          <button
            [ngClass]="{
              active:
                filterForm.controls['instanceTypes']?.value === InstanceTypes?.CPU
            }"
            class="chip"
            (click)="setInstanceTypes(InstanceTypes?.CPU)"
          >
            {{ instanceTypesLabels[InstanceTypes?.CPU] }}
          </button>
          <button
            [ngClass]="{
              active:
                filterForm.controls['instanceTypes']?.value === InstanceTypes?.GPU
            }"
            class="chip"
            (click)="setInstanceTypes(InstanceTypes?.GPU)"
          >
            {{ instanceTypesLabels[InstanceTypes?.GPU] }}
          </button>
        </div>
      </div>

      <!-- Usage Category Filter (Only visible when GPU is selected) -->
      <div
        class="mb-3 my-3"
        *ngIf="
          dialogData?.config?.usageCategory &&
          filterForm.controls['instanceTypes']?.value === InstanceTypes?.GPU
        "
      >
        <app-input-label label="Usage Category"></app-input-label>
        <div class="d-flex gap-2 mt-2">
          <button
            [ngClass]="{
              active:
                filterForm.controls['usageCategory']?.value ===
                UsageCategory?.Basic
            }"
            class="chip"
            (click)="setUsageCategory(UsageCategory?.Basic)"
          >
            {{ usageCategoryLabels[UsageCategory?.Basic] }}
          </button>
          <button
            [ngClass]="{
              active:
                filterForm.controls['usageCategory']?.value ===
                UsageCategory?.Advance
            }"
            class="chip"
            (click)="setUsageCategory(UsageCategory?.Advance)"
          >
            {{ usageCategoryLabels[UsageCategory?.Advance] }}
          </button>
        </div>
      </div>

      <ng-template let-controlName="controlName" #resetFilter>
        <span
          class="reset-control text-xs text-primary fw-500 cursor-pointer position-absolute"
          (click)="this.filterForm.get(controlName)?.reset()"
          >Reset</span
        >
      </ng-template>
    </form>
  </mat-dialog-content>

  <mat-dialog-content align="end" class="pt-1">
    <button
      class="text-black fw-500 btn btn-bordered-gray"
      (click)="onClearFilters()"
    >
      Clear
    </button>
    <button type="button" class="fw-500 btn btn-black ms-2 mb-2" (click)="onApplyFilters()" [disabled]="isApplyDisabled()">
      Apply
    </button>
  </mat-dialog-content>
</ng-container>
